import {
  MDBBtn,
  MDBCard,
  MDBCardBody,
  MDBCardText,
  MDBCardTitle,
  MDBCheckbox,
  MDBCol,
  MDBContainer,
  MDBIcon,
  MDBModalFooter,
  MDBRadio,
  MDBRow,
  MDBSelect,
  MDBSpinner,
  MDBTextArea,
} from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Tooltip } from "react-tooltip";
import SMSBrandSelection from "../../views/popups/globalaccount/brandAndSMS/SMSBrandSelection";
import SMSUseCaseSelection from "../../views/popups/globalaccount/brandAndSMS/SMSUseCaseSelection";
import CampaignDetails from "../../views/popups/globalaccount/brandAndSMS/CampaignDetails";
import { useForm } from "react-hook-form";
import { createSMSCampaign, getMisc } from "../../apiclients/streamsapi_bridge";
import { useNavigate } from "react-router";
function AddSMSCampaign(props) {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const [selectedRegion, setSelectedRegion] = useState("IN");
  const { t, i18n } = useTranslation();

  const [verticalActive, setVerticalActive] = useState("tab1");
  const [visitedTabs, setVisitedTabs] = useState([]);
  const navigate = useNavigate();
  const [brands, setbrands] = useState([]);
  const [useCases, setuseCases] = useState([]);
  const [subUseCases, setsubUseCases] = useState([]);
  const [brandName, setbrandName] = useState("");
  const [brandwebsite, setbrandwebsite] = useState("");
  const [isloading, setIsloading] = useState(false);
  const [subcaseslist, setsubcasesList] = useState([]);
  const [optin, setoptin] = useState(
    `${brandName} Thank you for opting into our texting notifications. Message frequency may vary. Message and Data Rates may apply. To end messaging reply with STOP or HELP for more information.`
  );
  const [optOut, setoptOut] = useState(
    `${brandName} You are no longer subscribed to our updates and will no longer receive messages. You may reply START to restart them at any time.`
  );

  const [subshelp, setsubshelp] = useState(
    `${brandName} Text START to join, text STOP to leave, or you may contact us at ${brandwebsite} for further assistance.`
  );
  const {
    register,
    handleSubmit,
    formState: { isDirty, dirtyFields, errors },
    reset,
    watch,
    clearErrors,
    setError,
    control,
    setValue,
  } = useForm({
    defaultValues: {
      brand_id: "",
      usecases: {
        case: 0,
        subcase: [],
      },
      campaign_details: {
        camp_desc: {
          desc: "",
          msg_flow: "",
          smpl_msgs: {
            one: "",
            two: "",
            five: "",
            four: "",
            three: "",
            smpl_msg_len: 1000,
          },
          msg_flow_chk: false,
        },
        camp_attribs: {
          num_pool: false,
          age_gated: false,
          embed_phn: false,
          embed_link: false,
          direct_lend: false,
        },
      },
    },
  });

  const handleVerticalClick = (tab) => {
    setVerticalActive(tab);
    if (!visitedTabs.includes(tab)) {
      setVisitedTabs([...visitedTabs, tab]);
    }
  };

  const handleNextClick = () => {
    const tabs = ["tab1", "tab2", "tab3", "tab4"];
    const currentIndex = tabs.indexOf(verticalActive);
    if (currentIndex < tabs.length - 1) {
      setVerticalActive(tabs[currentIndex + 1]);
      if (!visitedTabs.includes(tabs[currentIndex + 1])) {
        setVisitedTabs([...visitedTabs, tabs[currentIndex + 1]]);
      }
    } else {
      props.nextPageclick();
    }
  };

  const handlePreviousClick = () => {
    const tabs = ["tab1", "tab2", "tab3", "tab4"];
    const currentIndex = tabs.indexOf(verticalActive);
    if (currentIndex > 0) {
      setVerticalActive(tabs[currentIndex - 1]);
      if (visitedTabs.includes(tabs[currentIndex - 1])) {
        setVisitedTabs(visitedTabs.filter((tab) => tab !== tabs[currentIndex]));
      }
    }
  };

  const [formValue, setFormValue] = useState({
    fname: "Mark",
    lname: "Otto",
    email: "",
    city: "",
    state: "",
    zip: "",
  });

  const onChange = (e) => {
    setFormValue({ ...formValue, [e.target.name]: e.target.value });
  };

  const handleSubmits = () => {
    // Add your form submission logic here

    // After successful submission, change the active tab
    setVerticalActive("tab2"); // Change this to the desired tab value
  };
  const [uploadedFiles, setUploadedFiles] = useState([]);

  const handleFileChange = (event) => {
    const files = event.target.files;
    const newUploadedFiles = [...uploadedFiles]; // Copy existing files

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const fileSizeInMB = file.size / (1024 * 1024); // Convert bytes to MB

      if (fileSizeInMB <= 25) {
        // Check if file size is within limit
        newUploadedFiles.push(file.name);
      } else {
        alert(`File '${file.name}' exceeds the maximum file size of 25 MB.`);
      }
    }

    setUploadedFiles(newUploadedFiles);
  };

  const handleDeleteFile = (index) => {
    const newUploadedFiles = [...uploadedFiles];
    newUploadedFiles.splice(index, 1);
    setUploadedFiles(newUploadedFiles);
  };

  useEffect(() => {
    if (props.isActive) {
      getCampaignMisc();
    }
  }, [props.isActive]);

  async function getCampaignMisc() {
    let updates = {};
    console.log(sessionStorage.getItem("admin_session"));
    updates = {
      misc: ["campaign_registration"],
    };

    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      updates
    );
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const basicInfo = await response.json();
    if (!basicInfo) {
      window.alert(`info with id  not found`);
      navigate("/");
    }
    console.log(
      "response data for brand list is :::::::::: " + JSON.stringify(basicInfo)
    );

    setbrands(basicInfo?.misc?.campaign_registration?.active_brands ?? []);
    setuseCases(basicInfo?.misc?.campaign_registration?.usecases ?? []);
    setsubUseCases(basicInfo?.misc?.campaign_registration?.sub_usecases ?? []);
  }

  const steps = ["Brand Selection", "Use Case Selection", "Campaign Details"];
  const [currentStep, setCurrentStep] = useState(0);

  const handleNext = async (data) => {
    let finalUpdate = {};

    console.log("dirtyFields:", JSON.stringify(dirtyFields));
    console.log("data:", JSON.stringify(data));
    // setIsloading(true);

    // if (currentStep === 0) {
    //   finalUpdate = { brand_id: data.brand_id };

    // } else if(currentStep === 1) {
    //   const { usecases: keys } = dirtyFields;
    //   const { usecases: keysData } = data;
    //   let modifiedData = {};

    //   if (!Array.isArray(keysData)) {
    //     modifiedData = Object.fromEntries(
    //       Object.keys(keys).map((field) => [field, keysData[field]])
    //     );
    //   } else {
    //     modifiedData = [...keysData];
    //   }

    //   finalUpdate = { usecases: modifiedData };
    // } else {
    //   finalUpdate = extractModifiedFields(dirtyFields, data);
    // }

    // if (Object.keys(finalUpdate).length > 0) {
    //   const session = JSON.parse(sessionStorage.getItem("admin_session"));
    //   finalUpdate = {
    //     ...finalUpdate,
    //     reqid: 106,
    //     siteid: session.siteid,
    //     flow_step: currentStep + 1,
    //     ...(currentStep === 2 && { submit_type: 1 }),
    //   };

    //   console.log(
    //     "final request SMS Campaign:::::::::::::::: " + JSON.stringify(finalUpdate)
    //   );

    //   const response = await createSMSCampaign(finalUpdate);

    //   const responseMsg = await response.json();
    //   console.log("Response:", responseMsg);
    //   setIsloading(false);

    //   if (responseMsg.status === "success") {
    //     if (currentStep === 2) {
    //       localStorage.setItem("s_message", responseMsg.message);
    //       navigate("/smslanding", {
    //   state: { tab: "tab2" },
    // });
    // window.location.reload();
    //     } else {
    setCurrentStep(currentStep + 1);
    //     }
    //   } else if (responseMsg.message?.errors) {
    //     responseMsg.message.errors.forEach(({ param_name, message }) => {
    //       setError(param_name, { type: "server", message });
    //       const fieldElement = document.querySelector(
    //         `input[name="${param_name}"]`
    //       );
    //       fieldElement?.focus();
    //       fieldElement?.scrollIntoView({ behavior: "smooth" });
    //     });
    //   }
    // }
  };

  function extractModifiedFields(dirtyFields, data) {
    const modifiedData = {};

    function recurse(dirtyFields, data, modifiedData) {
      for (const field of Object.keys(dirtyFields)) {
        if (dirtyFields[field] && data.hasOwnProperty(field)) {
          if (typeof data[field] === "object" && !Array.isArray(data[field])) {
            modifiedData[field] = {};
            recurse(dirtyFields[field], data[field], modifiedData[field]);
          } else {
            modifiedData[field] = data[field];
          }
        }
      }
    }

    recurse(dirtyFields, data, modifiedData);
    return modifiedData;
  }

  useEffect(() => {
    if (props.draftDetails && Object.keys(props.draftDetails).length > 0) {
      setValue("brand_id", props.draftDetails?.sms_campaigns?.brand_id ?? "");
      setValue(
        "usecases.case",
        props.draftDetails?.sms_campaigns?.usecases?.case ?? 0
      );
      setValue(
        "usecases.subcase",
        props.draftDetails?.sms_campaigns?.usecases?.subcase ?? []
      );
      setValue(
        "campaign_details.camp_desc.desc",
        props.draftDetails?.sms_campaigns?.campaign_details?.desc ?? ""
      );
      setValue(
        "campaign_details.camp_desc.msg_flow",
        props.draftDetails?.sms_campaigns?.campaign_details?.msg_flow ?? ""
      );
      setValue(
        "campaign_details.camp_desc.smpl_msgs.one",
        props.draftDetails?.sms_campaigns?.campaign_details?.smpl_msgs?.one ??
        ""
      );
      setValue(
        "campaign_details.camp_desc.smpl_msgs.two",
        props.draftDetails?.sms_campaigns?.campaign_details?.smpl_msgs?.two ??
        ""
      );
      setValue(
        "campaign_details.camp_desc.smpl_msgs.three",
        props.draftDetails?.sms_campaigns?.campaign_details?.smpl_msgs?.three ??
        ""
      );
      setValue(
        "campaign_details.camp_desc.smpl_msgs.four",
        props.draftDetails?.sms_campaigns?.campaign_details?.smpl_msgs?.four ??
        ""
      );
      setValue(
        "campaign_details.camp_desc.smpl_msgs.five",
        props.draftDetails?.sms_campaigns?.campaign_details?.smpl_msgs?.five ??
        ""
      );
      setValue(
        "campaign_details.camp_desc.msg_flow_chk",
        props.draftDetails?.sms_campaigns?.campaign_details?.msg_flow_chk ??
        false
      );
      setValue(
        "campaign_details.camp_attribs.num_pool",
        props.draftDetails?.sms_campaigns?.camp_attribs?.num_pool ?? false
      );
      setValue(
        "campaign_details.camp_attribs.age_gated",
        props.draftDetails?.sms_campaigns?.camp_attribs?.age_gated ?? false
      );
      setValue(
        "campaign_details.camp_attribs.embed_phn",
        props.draftDetails?.sms_campaigns?.camp_attribs?.embed_phn ?? false
      );
      setValue(
        "campaign_details.camp_attribs.embed_link",
        props.draftDetails?.sms_campaigns?.camp_attribs?.embed_link ?? false
      );
      setValue(
        "campaign_details.camp_attribs.direct_lend",
        props.draftDetails?.sms_campaigns?.camp_attribs?.direct_lend ?? false
      );
      setsubcasesList(
        props.draftDetails?.sms_campaigns?.usecases?.subcase ?? []
      );

      setoptin(props.draftDetails?.campaign_details?.optin_msg ?? "");
      setoptOut(props.draftDetails?.campaign_details?.opt_out_msg ?? "");
      setsubshelp(props.draftDetails?.campaign_details?.help_msg ?? "");

      setCurrentStep(parseInt(props?.draftDetails?.flow_step) - 1);
    }
  }, [props.draftDetails]);

  async function handleDraft(data) {
    let finalUpdate = {};

    console.log("dirtyFields:", JSON.stringify(dirtyFields));
    console.log("data:", JSON.stringify(data));
    setIsloading(true);

    finalUpdate = extractModifiedFields(dirtyFields, data);

    if (Object.keys(finalUpdate).length > 0) {
      const session = JSON.parse(sessionStorage.getItem("admin_session"));
      finalUpdate = {
        ...finalUpdate,
        reqid: 106,
        siteid: session.siteid,
        flow_step: currentStep + 1,
        submit_type: 2,
      };

      console.log(
        "final request :::::::::::::::: " + JSON.stringify(finalUpdate)
      );

      const response = await createSMSCampaign(finalUpdate);

      const responseMsg = await response.json();
      console.log("Response:", responseMsg);
      setIsloading(false);

      if (responseMsg.status === "success") {
        navigate("/smslanding", {
          state: { tab: "tab2" },
        });
        window.location.reload();
      } else if (responseMsg.message?.errors) {
        responseMsg.message.errors.forEach(({ param_name, message }) => {
          setError(param_name, { type: "server", message });
          const fieldElement = document.querySelector(
            `input[name="${param_name}"]`
          );
          fieldElement?.focus();
          fieldElement?.scrollIntoView({ behavior: "smooth" });
        });
      }
    }
  }
  // const handleNext = () => {
  //   if (currentStep < steps.length - 1) {
  //     setCurrentStep(currentStep + 1);
  //   }
  // };
  const handleBack = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };
  const handleReset = () => {
    setCurrentStep(0);
  };
  const stepContent = [
    <>
      <SMSBrandSelection
        register={register}
        watch={watch}
        setValue={setValue}
        brands={brands}
        setbrandName={setbrandName}
        setbrandwebsite={setbrandwebsite}
      />
    </>,
    <>
      <SMSUseCaseSelection
        register={register}
        watch={watch}
        setValue={setValue}
        useCases={useCases}
        subUseCases={subUseCases}
        subcaseslist={subcaseslist}
      />
    </>,
    <>
      <CampaignDetails
        register={register}
        watch={watch}
        setValue={setValue}
        // brandName={brandName}
        // brandwebsite={brandwebsite}
        optin={optin}
        optOut={optOut}
        subshelp={subshelp}
      />
    </>,
  ];
  return (
    <>
      <MDBContainer>
        <div className="stepper-container">
          <div className="stepper">
            {steps.map((step, index) => (
              <>
                <div
                  key={index}
                  className={`step ${index <= currentStep ? "active" : ""}`}
                >
                  <div className="step-number">{index + 1}</div>
                  <div className="step-label ms-2">{step}</div>
                </div>
              </>
            ))}
          </div>

          <div className="stepper-content">{stepContent[currentStep]}</div>
        </div>
      </MDBContainer>
      <MDBModalFooter className="d-block">
        {/* <p className='red'>Note: It is extremely important that all information submitted be accurate, as incorrect data will delay processing and can result in rejection.</p> */}
        <div className="d-flex justify-content-between">
          <MDBBtn
            className="text-normal-case"
            color="secondary"
            onClick={(e) => {
              e.preventDefault();
              handleSubmit(handleDraft)();
            }}
          >
            Save to Draft
          </MDBBtn>
          <div className="text-end">
            <MDBBtn color="secondary" className="me-2" onClick={handleBack}>
              Previous
            </MDBBtn>
            <MDBBtn
              onClick={(e) => {
                e.preventDefault();
                handleSubmit(handleNext)();
              }}
            >
              Next
            </MDBBtn>
          </div>
        </div>
      </MDBModalFooter>
      {isloading && (
        <>
          <div className="loadingclass">
            <MDBBtn disabled>
              <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
              Loading...
            </MDBBtn>
          </div>
        </>
      )}
    </>
  );
}
export default AddSMSCampaign;
